import { createSelector } from 'reselect';
import { getSkipSetupParts } from './getSkipSetupParts';
import { getUnattendedSkipLaborTicketFormEnabled } from './getUnattendedSkipLaborTicketFormEnabled';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getUnattendedOperatorPersonId } from './getUnattendedOperatorPersonId';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';

/**
 * Whether submit work / sign out opens the zero-parts setup action modal
 * instead of the full labor ticket form. Skip Setup Parts covers setup
 * tickets; a separate flag covers open tickets owned by the shared Unattended
 * operator, so shops that report setup scrap can still skip the Unattended
 * form. APM submits Unattended tickets through its own flow, so it keeps the
 * form.
 */
export const getUseSetupActionModal = createSelector(
  [
    getSkipSetupParts,
    getUnattendedSkipLaborTicketFormEnabled,
    getCurrentLaborTicket,
    getUnattendedOperatorPersonId,
    getIsApmERPJobFlow,
  ],
  (
    skipSetupParts,
    unattendedSkipForm,
    currentLaborTicket,
    unattendedPersonId,
    isApmERPJobFlow
  ) => {
    if (!currentLaborTicket) {
      return false;
    }
    if (currentLaborTicket.type?.toLowerCase() === 'setup') {
      return skipSetupParts;
    }
    return (
      unattendedSkipForm &&
      !isApmERPJobFlow &&
      currentLaborTicket.state !== 'CLOSED' &&
      !!unattendedPersonId &&
      currentLaborTicket.personId === unattendedPersonId
    );
  }
);
